import {renderKnowledgeType} from "../../controllers/SystemQuestionKnowledgeController";
import {isNullOrUndefined} from "../../services/Validator";

export default function SystemKnowledgeTypeText({knowledgeType}) {
    // Used in SystemQuestionKnowledge to display Question
    // knowledge definition to know by heart

    // PROPERTIES
    const knowledgeTypeObject = renderKnowledgeType(knowledgeType, 0);

    // BUILD
    if (isNullOrUndefined(knowledgeType))
        return null
    return (
        <div className={"flex justify-start items-center space-x-6 text-greyLight5 -ml-2 leading-relaxed"}>
            <i className="material-icons text-[16px]">
                {knowledgeTypeObject.icon}
            </i>
            <span className={"text-[14px] font-medium"}>
                {knowledgeTypeObject.title}
            </span>
        </div>
    );
}